import { SVGProps } from "react";
const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g filter="url(#filter0_dd_3169_4950)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.3107 7.81066C18.8964 7.22487 18.8964 6.27513 18.3107 5.68934C17.7249 5.10355 16.7751 5.10355 16.1893 5.68934L12 9.87868L7.81066 5.68934C7.22487 5.10355 6.27513 5.10355 5.68934 5.68934C5.10355 6.27513 5.10355 7.22487 5.68934 7.81066L9.87868 12L5.68934 16.1893C5.10355 16.7751 5.10355 17.7249 5.68934 18.3107C6.27513 18.8964 7.22487 18.8964 7.81066 18.3107L12 14.1213L16.1893 18.3107C16.7751 18.8964 17.7249 18.8964 18.3107 18.3107C18.8964 17.7249 18.8964 16.7751 18.3107 16.1893L14.1213 12L18.3107 7.81066Z"
				fill="white"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_3169_4950"
				x={5.25}
				y={5.25}
				width={13.5}
				height={15.5}
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB">
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy={1} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_4950" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_3169_4950" result="effect2_dropShadow_3169_4950" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3169_4950" result="shape" />
			</filter>
		</defs>
	</svg>
);
export default CrossIcon;

